/**
 * user login
 */
export const USER_LOGIN = "/api/loginUser";

/**
 * verify login token
 */
export const VERIFY_LOGIN_TOKEN = "/api/verifyLoginToken";

/**
 * get member by id
 */
export const GET_MEMBER_BY_ID = "/api/getMemberById";

/**
 * get member mobile ids
 */
export const GET_MEMBER_MOBILE = "/api/getMemberMobile";

/**
 * get return messages by page
 */
export const GET_RETURN_MESSAGE_BY_PAGE = "/api/getReturnMessageByPage";

/**
 * get forward status by page
 */
export const GET_FORWARD_STATUS_BY_PAGE = "/api/getForwardStatusByPage";

/**
 * submit raw messages
 */
export const SUBMIT_RAW_MESSAGES = "/api/submitRawMessages";

/**
 * submit encoded messages
 */
export const SUBMIT_ENCODED_MESSAGES = "/api/submitEncodedMessages";

/**
 * get encoded command definitions
 */
export const GET_ENCODED_DEFINITIONS = "/api/getEncodedDefinitions";

/**
 * user logout
 */
export const LOGOUT_USER = "/api/logoutUser";

/**
 * modify password
 */
export const MODIFY_PASSWORD = "/api/modifyPassword";

/**
 * get all login log (paged)
 */
export const GET_ALL_LOG_LOGIN = "/api/getAllLogLogin";

/**
 * get all company (paged)
 */
export const GET_ALL_COMPANY = "/api/getAllCompany";

/**
 * get all member (paged)
 */
export const GET_ALL_MEMBER = "/api/getAllMember";

/**
 * add member
 */
export const ADD_MEMBER = "/api/addMember";

/**
 * modify member
 */
export const MODIFY_MEMBER = "/api/modifyMember";

/**
 * update member enable
 */
export const UPDATE_MEMBER_ENABLE = "/api/updateMemberEnable";

/**
 * add company
 */
export const ADD_COMPANY = "/api/addCompany";

/**
 * modify company by id
 */
export const MODIFY_COMPANY_BY_ID = "/api/modifyCompanyById";

/**
 * get all mobile (paged)
 */
export const GET_ALL_MOBILE = "/api/getAllMobile";

/**
 * add mobile
 */
export const ADD_MOBILE = "/api/addMobile";

/**
 * modify mobile by id
 */
export const MODIFY_MOBILE_BY_ID = "/api/modifyMobileById";

/**
 * update mobile enable
 */
export const UPDATE_MOBLIE_ENABLE = "/api/updateMoblieEnable";

/**
 * send verify code for forgot password
 */
export const SEND_VERIFY_CODE = "/api/sendVerifyCode";

/**
 * check verify code for forgot password
 */
export const CHECK_VERIFY_CODE = "/api/checkVerifyCode";

/**
 * reset password by account
 */
export const RESET_PASSWORD_BY_ACCOUNT = "/api/resetPasswordByAccount";
